import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import moment from 'moment';

import TapIcon from '../../../../services/TapIcon';
import { DisplaySearchCriteria } from '../../../../components/TapUi';
import PeriodSelectionWithSeparateDates from '../../../../components/TapUi/PeriodSelectionWithCustom/PeriodSelectionWithSeparateDates';
import { useSelector } from 'react-redux';
import download from '../../../../services/DownloadFile';
import { IAM_API_BASE_URL_2, IAM_COUNTERLOG_URL } from '../../../../services/TapApiUrls';
import api from '../../../../services/api';

const DownloadPeriodModal = forwardRef((props, ref) => {
    const all_period = useSelector(state => state.app && state.app.all_periods || []);
    const access_token = useSelector(state => state.auth.access_token);
    const searchModalElem = useRef(null);
    const searchModal = useRef(null);
    
    const initFormData = {
        loading: false,
        submitting: false,
    };

    const [selectedPeriodData, setSelectedPeriodData] = useState({
        date_range: '',
        date_range_start: null,
        date_range_end: null,
    });

    const [formData, setFormData] = useState(initFormData);
    const [searchModalId] = useState(uuid());
    const [allPeriods, setAllPeriods] = useState([]);

    const searchModalOpen = () => searchModal.current && searchModal.current.show();
    const searchModalClose = () => searchModal.current && searchModal.current.hide();

    const resetForm = () => {
        setFormData(initFormData);
        setSelectedPeriodData({
            date_range: '',
            date_range_start: null,
            date_range_end: null,
        });
    };

    useEffect(() => {



 

        const periodsWithCustom = [...all_period.filter(p =>  p.key === 'today' || p.key === 'yesterday')  ];
        if (!periodsWithCustom.find(p => p.key === 'custom')) {
            periodsWithCustom.push({ key: 'custom', display: 'Custom Date Range' });
        }
        setAllPeriods(periodsWithCustom);
        searchModalElem.current = document.getElementById(searchModalId);
        searchModal.current = new Modal(searchModalElem.current, { keyboard: false, backdrop: false });

        const handleModalHidden = () => {
            resetForm();
        };

        searchModalElem.current.addEventListener('hidden.bs.modal', handleModalHidden);

        return () => {
            if (searchModalElem.current) {
                searchModalElem.current.removeEventListener('hidden.bs.modal', handleModalHidden);
            }
            searchModal.current && searchModal.current.dispose();
        };
    }, []);

    useImperativeHandle(ref, () => ({
        initModalDownloadHandler: () => searchModalOpenHandler(),
        initModalClose: () => editModalCloseHandler(),
    }));

    const searchModalOpenHandler = () => {
        resetForm();
        searchModalOpen();
    };

    const editModalCloseHandler = () => {
        searchModalClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!selectedPeriodData.date_range_start || !selectedPeriodData.date_range_end) {
            toast.error("Please select Start Date and End Date", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        setFormData({ ...formData, submitting: true });
        const filterParams = props.filterParams || {};

        const params = {
            ...filterParams,
            date_range: selectedPeriodData.date_range,
            date_range_start: moment(selectedPeriodData.date_range_start).format('YYYY-MM-DD'),
            date_range_end: moment(selectedPeriodData.date_range_end).format('YYYY-MM-DD'),
            download: 'downloadv2',
        };

        Object.keys(params).forEach(key => {
            if (params[key] === '' || params[key] === null || (Array.isArray(params[key]) && params[key].length === 0)) {
                delete params[key];
            }
        });

        api.server2Api.get(IAM_COUNTERLOG_URL + '/v2/asset_wise_shift_reading', { 
            params: params, 
            headers: { 'Authorization': 'Bearer ' + access_token } 
        }).then((resp) => {
            if (resp?.data && resp?.data?.file_path) {
                download.file(resp.data.file_path);
                toast.success("Logsheet downloaded successfully!", { position: toast.POSITION.TOP_RIGHT });
            }
            editModalCloseHandler(); 
        }).catch((error) => {
            toast.error(error.message, { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setFormData({ ...formData, submitting: false });
        });
    };

    return (
        <div
            className="modal fade"
            id={searchModalId}
            tabIndex="-1"
            ref={searchModalElem}
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">
                            Download Daily Logsheet
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            disabled={formData.submitting}
                        />
                    </div>

                    <div className="modal-body">
                        <form id={searchModalId + "Form"} onSubmit={handleSubmit}>
                            {props.searchedElems && props.searchedElems.length > 0 && (
                                <DisplaySearchCriteria
                                    searchedElems={props.searchedElems}
                                />
                            )}
                            <div className="my-4 row align-items-center">
                                <div className="col-3">
                                <label className="form-label fw-bold require ">
                                    Select Date Range
                                </label>
                                </div>
                                <div className="col-9">
                                <PeriodSelectionWithSeparateDates
                                    periods={allPeriods}
                                    menuPlacement="bottom"
                                    value={selectedPeriodData.date_range}
                                    startDate={selectedPeriodData.date_range_start}
                                    endDate={selectedPeriodData.date_range_end}
                                    onSelectPeriod={(date_range, startDate, endDate) => {
                                        setSelectedPeriodData({
                                            date_range: date_range || '',
                                            date_range_start: startDate || null,
                                            date_range_end: endDate || null,
                                        });
                                    }}
                                    required ={true}
                                />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            disabled={formData.submitting}
                        >
                            Close
                        </button>
                        
                        <button
                            form={searchModalId + "Form"}
                            type="submit"
                            className="btn btn-primary"
                            disabled={formData.submitting}
                        >
                            Download
                            {formData.submitting && (
                                <TapIcon.FontAwesomeIcon
                                    icon={TapIcon.faSyncAlt}
                                    className="fa-spin ms-2"
                                />
                            )}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
});

export default DownloadPeriodModal;